import { useState } from "react";
import UIBody from "../../../components/ui/UIBody";
import useApiCallHooks from "../../../hooks/useApiCallHooks";
import { apiRoutes } from "../../../routes/api/apiRoutes";
import { toast } from "react-toastify";
import { uiRoutes } from "../../../routes/ui/uiRoutes";
import { useNavigate } from "react-router-dom";

const MentorRegister = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [isShow, setShow] = useState();
  const navigate = useNavigate();
  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_no: "",
    skills: "",
    experiance: "",
    profile_pic: "",
    resume: "",
    linkedin_profile: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault(); // ⛔ Prevent default form submission
    // IF only for file upload
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    formData.append("profile_pic", data.profile_pic); // Append the file directly
    formData.append("resume", data.resume); // Append the file directly
    //End Only file upload
    callAPI("post", apiRoutes.webiste.mentorRequest, formData);
  };

  if (responce?.data && !isShow) {
    toast.success("Mentor Register Successfully !");
    setShow(true);
    setTimeout(() => {
      navigate(uiRoutes.website.home);
    }, 1000);
  }
  return (
    <UIBody
      loading={loading}
      content={
        <section className="mt-md-5 pb-5 container">
          <div className="row">
            {/* Left Side: Background Image */}
            <div className="col-md-6 p-0">
              <div
                className="image-container d-flex flex-column justify-content-center align-items-center p-4 h-100"
                style={{ backgroundColor: "#f8f9fa" }}
              >
                <h2
                  className="mb-4 text-center"
                  style={{ fontWeight: "bold", color: "#333" }}
                >
                  Mentor Registration Workflow
                </h2>
                <div className="steps-container w-100">
                  <div className="step-box d-flex align-items-center">
                    <span className="icon-circle">
                      <i className="fas fa-edit" />
                    </span>
                    <p className="m-0  text-start crl-p">
                      Sign up and Become a Mentor with SysInsight{" "}
                    </p>
                  </div>
                  <div className="arrow">↓</div>
                  <div className="step-box d-flex align-items-center">
                    <span className="icon-circle">
                      <i className="fas fa-envelope-open-text" />
                    </span>
                    <p className="m-0  text-start crl-p">
                      Admin Accepts Your Application
                    </p>
                  </div>
                  <div className="arrow">↓</div>
                  <div className="step-box d-flex align-items-center">
                    <span className="icon-circle">
                      <i className="fas fa-user-check" />
                    </span>
                    <p className="m-0  text-start crl-p">
                      Get Approved and Connect with Mentees
                    </p>
                  </div>
                  <div className="arrow">↓</div>
                  <div className="step-box d-flex align-items-center">
                    <span className="icon-circle">
                      <i className="fas fa-sign-in-alt" />
                    </span>
                    <p className="m-0  text-start crl-p">
                      Guide Students and Earn Rewards
                    </p>
                  </div>
                  <div className="arrow">↓</div>
                  <div className="step-box d-flex align-items-center">
                    <span className="icon-circle">
                      <i className="fas fa-tasks" />
                    </span>
                    <p className="m-0  text-start crl-p">
                      Monitor Growth and Student Careers
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Right Side: Registration Form */}
            <div className="col-md-6">
              <section className="singUp-area">
                <div className="singUp-wrap">
                  <h2 className="title">Guide and Inspire</h2>
                  <p>
                    Train, guide, and share industry insights with students.
                  </p>
                  <form className="account__form" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6 form-grp new-design">
                        <label htmlFor="name">First Name</label>
                        <input
                          type="text"
                          id="nameField"
                          name="name"
                          className="form-control"
                          placeholder="Enter Your Full Name"
                          required=""
                          onChange={(e) =>
                            setData({
                              ...data,
                              first_name: e.target.value,
                            })
                          }
                        />
                        <span className="val-message">
                          {error?.message === "ValidationError" &&
                            error?.data?.first_name}{" "}
                        </span>
                      </div>
                      <div className="col-md-6 form-grp new-design">
                        <label htmlFor="email">Last Name</label>
                        <input
                          type="text"
                          placeholder="Test"
                          onChange={(e) =>
                            setData({
                              ...data,
                              last_name: e.target.value,
                            })
                          }
                        />
                        <span className="val-message">
                          {error?.message === "ValidationError" &&
                            error?.data?.last_name}{" "}
                        </span>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 form-grp new-design">
                        <label htmlFor="experience">Experience</label>
                        <input
                          type="text"
                          id="experience"
                          name="experiance"
                          placeholder="Enter Your Experience"
                          required=""
                          onChange={(e) =>
                            setData({
                              ...data,
                              experiance: e.target.value,
                            })
                          }
                        />
                        <span className="val-message">
                          {error?.message === "ValidationError" &&
                            error?.data?.experiance}{" "}
                        </span>
                      </div>
                      <div className="col-md-6 form-grp new-design">
                        <label htmlFor="phone">Mobile No.</label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          placeholder="Enter Your Mobile No."
                          pattern="[0-9]{10}"
                          maxLength={10}
                          required=""
                          onChange={(e) =>
                            setData({
                              ...data,
                              mobile_no: e.target.value,
                            })
                          }
                        />
                        <span className="val-message">
                          {error?.message === "ValidationError" &&
                            error?.data?.mobile_no}{" "}
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 form-grp new-design">
                        <label htmlFor="email">Email</label>
                        <input
                          type="text"
                          placeholder="your@email.com"
                          onChange={(e) =>
                            setData({
                              ...data,
                              email: e.target.value,
                            })
                          }
                        />
                        <span className="val-message">
                          {error?.message === "ValidationError" &&
                            error?.data?.email}{" "}
                        </span>
                      </div>
                      <div className="col-md-6 form-grp new-design">
                        <label htmlFor="image">Profile</label>
                        <input
                          type="file"
                          name="image"
                          id="image"
                          required=""
                          onChange={(e) =>
                            setData({
                              ...data,
                              profile_pic: e.target.files[0],
                            })
                          }
                        />
                        <span className="val-message">
                          {error?.message === "ValidationError" &&
                            error?.data?.profile_pic}{" "}
                        </span>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 form-grp new-design">
                        <label htmlFor="linkedin">LinkedIn Profile</label>
                        <input
                          type="url"
                          id="linkedin"
                          name="linkedin"
                          placeholder="LinkedIn Profile Link"
                          required=""
                          onChange={(e) =>
                            setData({
                              ...data,
                              linkedin_profile: e.target.value,
                            })
                          }
                        />
                        <span className="val-message">
                          {error?.message === "ValidationError" &&
                            error?.data?.linkedin_profile}{" "}
                        </span>
                      </div>
                      <div className="col-md-6 form-grp new-design">
                        <label htmlFor="resumeInput">Upload Resume</label>
                        <input
                          type="file"
                          name="file_path"
                          id="resumeInput"
                          required=""
                          onChange={(e) =>
                            setData({
                              ...data,
                              resume: e.target.files[0],
                            })
                          }
                        />
                        <span className="val-message">
                          {error?.message === "ValidationError" &&
                            error?.data?.resume}{" "}
                        </span>
                      </div>
                    </div>
                    <div className="form-grp new-design">
                      <label htmlFor="skillInput">Skills(Add Multiple)</label>
                      <div className="row">
                        <div className="col-12">
                          <input
                            type="text"
                            id="skillInput"
                            className="form-control"
                            placeholder="Enter a skill"
                            onChange={(e) =>
                              setData({
                                ...data,
                                skills: e.target.value,
                              })
                            }
                          />
                          <span className="val-message">
                            {error?.message === "ValidationError" &&
                              error?.data?.skills}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="skills-container mt-2" id="skillsList" />
                    <input type="hidden" name="skills" id="skillsField" />
                    <button
                      type="submit"
                      className="btn rounded text-white m-0 mt-4"
                    >
                      Register
                    </button>
                  </form>
                </div>
              </section>
            </div>
          </div>
        </section>
      }
    />
  );
};

export default MentorRegister;
